"use client";
import { useEffect, useState } from "react";

type UseOutsideClickReturn = [
  boolean, // isOpen
  () => void, // toggleState
  React.Dispatch<React.SetStateAction<boolean>> // setIsOpen
];

function useOutsideClick(
  wrapperId: string,
  containerId: string = "build-web-it-body",
  defaultState: boolean = false,
  callback?: () => void
): UseOutsideClickReturn {
  const [isOpen, setIsOpen] = useState<boolean>(defaultState);

  const toggleState = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    if (typeof document === "undefined") return;
    if (!containerId || !wrapperId) return;

    const wrapper = document.getElementById(containerId);
    const button = document.getElementById(wrapperId);

    if (!wrapper || !button) return;

    const abort = new AbortController();

    wrapper.addEventListener(
      "click",
      (e) => {
        const target = e.target as Node;
        if (button.contains(target)) {
          // clicked inside the button, ignore
        } else {
          setIsOpen(false);
          if (typeof callback === "function") {
            callback();
          }
        }
      },
      { signal: abort.signal }
    );

    return () => {
      abort.abort();
    };
  }, [containerId, wrapperId, callback]);

  return [isOpen, toggleState, setIsOpen];
}

export default useOutsideClick;
